var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgArrowCurvedUpToTray(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.25 3.5C2.69772 3.5 2.25 3.94772 2.25 4.5V7.5C2.25 8.05228 2.69772 8.5 3.25 8.5C3.80228 8.5 4.25 8.05228 4.25 7.5V5.5H20.25V7.5C20.25 8.05228 20.6977 8.5 21.25 8.5C21.8023 8.5 22.25 8.05228 22.25 7.5V4.5C22.25 3.94772 21.8023 3.5 21.25 3.5H3.25Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.25 21.5C2.69772 21.5 2.25 21.0523 2.25 20.5C2.25 19.9477 2.69772 19.5 3.25 19.5H8.25C9.90685 19.5 11.25 18.1569 11.25 16.5V11.9142L9.95711 13.2071C9.56658 13.5976 8.93342 13.5976 8.54289 13.2071C8.15237 12.8166 8.15237 12.1834 8.54289 11.7929L11.5429 8.79289C11.9334 8.40237 12.5666 8.40237 12.9571 8.79289L15.9571 11.7929C16.3476 12.1834 16.3476 12.8166 15.9571 13.2071C15.5666 13.5976 14.9334 13.5976 14.5429 13.2071L13.25 11.9142V16.5C13.25 19.2614 11.0114 21.5 8.25 21.5H3.25Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowCurvedUpToTray);
export default __webpack_public_path__ + "static/media/arrow_curved_up_to_tray.713d10be47544a4f3871d1371e48eedb.svg";
export { ForwardRef as ReactComponent };